import { format } from 'echarts/core';

/**
 * Tooltip for a dashboard pie slice. ECharts sets a function formatter's return value as innerHTML,
 * outside React's escaping, and the slice name is a display owner's name that tenants can set, so
 * every value is encoded before it goes into the markup.
 */
export const pieTooltipHtml = (name: string, label: string, value: string, percent: number) =>
    [
        `<strong>${format.encodeHTML(name)}</strong>`,
        `${format.encodeHTML(label)}: ${format.encodeHTML(value)} (${percent.toFixed(0)}%)`,
    ].join('<br/>');
